"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useReportItem = exports.reportMedia = void 0;
var _react = require("react");
var _contexts = require("../contexts");
var _logger = require("../logger");
var _models = require("../models");
var _externalUrl = require("./externalUrl");
/* istanbul ignore file @preserve --api */

const childLogger = _logger.mainLogger.createChild('useReportItem');
const reportMedia = async ({
  apiKey,
  email,
  reason,
  url
}) => {
  try {
    const {
      apiVersion,
      wrapResponses
    } = _externalUrl.baseConfig;
    const reportUrl = `${url}?version=${apiVersion}&auth_token=${apiKey}&wrap_responses=${wrapResponses}`;
    const response = await (0, _externalUrl.postExternalUrl)(reportUrl, {
      data: {
        email,
        reason
      },
      responseType: 'json'
    });
    const validatedResponse = _models.olapicResponseReportSchema.parse(response);
    return {
      code: validatedResponse.metadata.code,
      message: validatedResponse.metadata.message,
      error: validatedResponse.data?.message ?? ''
    };
  } catch (error) {
    childLogger.error(new Error('Error while reporting media', {
      cause: error
    }));
    return {
      code: 500,
      message: 'Internal server error',
      error: 'Internal server error'
    };
  }
};
exports.reportMedia = reportMedia;
const useReportItem = () => {
  const {
    apiKey
  } = (0, _contexts.useOlapicData)();
  const [reportStatus, setReportStatus] = (0, _react.useState)(_models.ReportStatus.new);
  const report = (0, _react.useCallback)(async ({
    email,
    reason,
    url
  }) => {
    setReportStatus(_models.ReportStatus.sending);
    const {
      code
    } = await reportMedia({
      apiKey,
      email,
      reason,
      url
    });
    if (code === 201) {
      setReportStatus(_models.ReportStatus.sent);
    } else {
      setReportStatus(_models.ReportStatus.error);
    }
  }, [apiKey]);
  return {
    reportStatus,
    report
  };
};
exports.useReportItem = useReportItem;
